import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Person } from '../models/person';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  //Cache - add to list on new person created, otherwise just retrieve every 15 minutes.
  people_list: Person[];
  last_lookup: Date;

  constructor(private http: HttpClient) { }

get(id: string): Promise<Person> {
  return this.getWithRest('id/' + id);
}

getForOrganizer(horse_show_organizer_id: string, id: string): Promise<Person> {
  return this.getWithRest('organizer_id/' + horse_show_organizer_id + '/id/' + id);
}

getList(): Promise<Person[]> {
  let now_date = new Date();
  if(this.last_lookup != undefined && ((now_date.getTime() - this.last_lookup.getTime()) / 1000) < 900){
    //Last lookup less than 15 minutes ago. Use cache
    return Promise.resolve(this.people_list);
  } else {
    return this.getListWithRest("");
  }

}

  private getWithRest(rest_url: string) : Promise<Person> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'people/' + rest_url).subscribe((response:any) => {

      if((response.type == 'user_person' || response.type == 'organizer_person') && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  private getListWithRest(rest_url: string) : Promise<Person[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'people/' + rest_url).subscribe((response:any) => {
			if(response.type == 'user_person_list' && response.data){
        this.people_list = response.data;
        this.last_lookup = new Date();
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  create(person: Person): Promise<Person> {

    let post_data = {
        data: {
          type: 'person',
          attributes: { person: person }
          }
      };

    	return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'people',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && (response.type=='person' || response.type=='user_person' || response.type == 'organizer_person')) {
                       this.updateList(response.data);
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
    }

    update(person: Person): Promise<Person> {

    let put_data = {
        data: {
          type: 'person',
          attributes: { person: person }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'people',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && (response.type=='person' || response.type=='user_person' || response.type == 'organizer_person')) {
                       this.updateList(response.data);
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
    }

    hide(person: Person): Promise<boolean> {
    let put_data = {
        data: {
          type: 'person_hide_request',
          attributes: { id: person.id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'people',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='person_hide_response') {
                         resolve(response.data);
                       }  else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                  reject(error.error.data);
                }
                reject(error);
                });
            });
  }


private updateList(person: Person){
  //If list hasn't been populated yet, ignore
  if(this.people_list == undefined) return;

        //Does person exist yet on resident list?
        let person_exists: boolean = false;
        this.people_list.forEach((existing_person, i) => {
            if(existing_person.id == person.id){
                this.people_list[i] = person;
                person_exists = true;
            }
        });

        if(!person_exists){
            this.people_list.push(person);
            this.sortPeopleList(this.people_list);

        }
    }

    sortPeopleList(people_list){
      people_list.sort( function(a_person, b_person) {
                if((a_person.last_name + a_person.first_name) < (b_person.last_name + b_person.first_name)){
                    return -1;
                } else if((a_person.last_name + a_person.first_name) > (b_person.last_name + b_person.first_name)){
                    return 1;
                } else {
                    return 0;
                }
            });
    }


}


